import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="screen-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-xl rise">
        <h1 className="font-display text-4xl sm:text-5xl font-black">Not tonight.</h1>
        <p className="pixel-text text-2xl text-[#9CA3AF] mt-4">Payment was cancelled. The cabin will wait for you.</p>
        <button className="pixel-btn mt-10" onClick={() => nav("/")} data-testid="payment-cancel-return-button">Back to chapters</button>
      </div>
    </div>
  );
}
